export default __webpack_public_path__ + "static/media/fergus_page_one.ac41fd4c.svg";